const LADO_MAXIMO = 1600;
const CALIDAD = 0.8;

const leerComoImagen = (file) =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("No se pudo leer la imagen"));
        };
        img.src = url;
    });

/**
 * Comprime una imagen a JPEG con un lado máximo y calidad determinada. 
 */
const comprimirImagen = async (file, indice = 0) => {
    try {
        const img = await leerComoImagen(file);
        const escala = Math.min(1, LADO_MAXIMO / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * escala);
        canvas.height = Math.round(img.height * escala);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", CALIDAD));
        if (!blob) return file;

        const nombre = `foto-${Date.now()}-${indice + 1}.jpg`;
        return new File([blob], nombre, { type: "image/jpeg", lastModified: Date.now() });
    } catch (error) {
        return file;
    }
};

export default comprimirImagen;
